import { useState } from 'react'
import { useSelector } from 'react-redux'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Alert } from 'antd'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Text from '~/core/Text'
import { getUserIdentity } from '~/redux-modules/identity'
import getColor from '~/lib/getColor'
import useImDfmOperations from '../logic'
import Link from '~/core/Link'

import NotifyFictivModal from './NotifyFictivModal'
import {
    DFM_HELP_ARTICLE_LINK,
    DFM_HELP_ARTICLE_TEXT,
    FICTIV_NOTIFIED,
    getAlertDescriptionText,
    getAlertTitleText,
    NOTIFY_FICTIV,
} from './logic'

type NotifyFictivAlertPropsType = {
    quoteId?: string
    orderId?: string
}

const NotifyFictivAlert = (props: NotifyFictivAlertPropsType) => {
    const { quoteId, orderId } = props

    const identity = useSelector(getUserIdentity)
    const userId = identity?.id

    const [modalVisible, setModalVisible] = useState<boolean>(false)
    const [fictivNotified, setFictivNotified] = useState<boolean>(false)

    const { notifyFictivAdmin, notifyFictivAdminOnOdp } = useImDfmOperations()

    const PLACEMENT = fictivNotified ? 'fictiv-notified' : 'notify-fictiv'

    const onClickNotifyFictiv = () => {
        setModalVisible(true)
        setFictivNotified(true)
        return orderId
            ? notifyFictivAdminOnOdp(userId, orderId)
            : notifyFictivAdmin(quoteId, userId)
    }

    return (
        <Box direction="col" paddingBottom="12px">
            <Alert
                message={
                    <Box border={getColor('borderBlue')} direction="row">
                        <InfoCircleOutlined
                            style={{
                                color: getColor('shroudBlue'),
                                fontSize: '16px',
                                margin: '2px 0 0 5px',
                            }}
                        />
                        <Box direction="col" marginLeft="16px">
                            <Text
                                fontSize="16px"
                                fontWeight={400}
                                style={{ paddingBottom: '4px' }}
                            >
                                {getAlertTitleText(fictivNotified)}
                            </Text>
                            <Box direction="col">
                                <Text
                                    fontSize="14px"
                                    style={{ paddingBottom: '16px' }}
                                >
                                    {getAlertDescriptionText(fictivNotified)}
                                </Text>
                                <Link
                                    data-test-target="dfm-help-article"
                                    href={DFM_HELP_ARTICLE_LINK}
                                    name="dfm-help-article"
                                    placement="dfm-help-article-link"
                                    target="_blank"
                                >
                                    {DFM_HELP_ARTICLE_TEXT}
                                </Link>
                            </Box>
                        </Box>
                        <Box display="block" marginLeft="auto">
                            <Button
                                name={`${PLACEMENT}-button`}
                                placement={PLACEMENT}
                                data-test-target={`${PLACEMENT}-alert-button`}
                                disabled={fictivNotified}
                                onClick={onClickNotifyFictiv}
                            >
                                {fictivNotified
                                    ? FICTIV_NOTIFIED
                                    : NOTIFY_FICTIV}
                            </Button>
                        </Box>
                        {modalVisible && (
                            <NotifyFictivModal
                                onClose={() => setModalVisible(false)}
                            />
                        )}
                    </Box>
                }
                style={{ padding: '16px' }}
            />
        </Box>
    )
}

export default NotifyFictivAlert
